import CANotifications from '@ds/components/notifications/CANotifications'
import { defineComponent } from 'vue'

import { createVueApp } from '@/entrypoints/createVueApp'

const NotificationWrapperComponent = defineComponent({
	name: 'NotificationWrapper',

	setup() {
		return () => <CANotifications />
	},
})

export default function () {
	const app = createVueApp(NotificationWrapperComponent)

	app.mount('#notificationWrapperApp')
}
